import Api from '@/api'

const api = new Api()
const apiSpec = api
  .sales()
  .bid()
  .spec()

export default {
  async fetchPaperwork({ commit }, payload) {
    try {
      const { bidNumber, site, sites } = payload

      const promises = (Array.isArray(sites) ? sites : [site]).map(site => apiSpec.paperwork(bidNumber, site).fetch())

      const responses = await Promise.all(promises)
      const resp = responses.at(0)

      responses.slice(1).forEach(item => {
        // merge paperwork
        if (item?.data?.data?.paperwork) {
          resp.data.data.paperwork = resp.data.data.paperwork.concat(item.data.data.paperwork)
        }
      })

      const response = resp.data.data
      commit('setPaperwork', response.paperwork ? response.paperwork : [])
      commit('setSettings', response.settings ? response.settings : [])
      commit('Dashboard/setFeedback', response, {
        root: true,
      })

      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        {
          root: true,
        },
      )
    }
  },
  // Specifications
  async fetchAuthority({ commit, state }, payload) {
    try {
      return await api
        .sales()
        .bid()
        .authority(payload)
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async addEquipment({ commit }, payload) {
    try {
      const { bidNumber, siteId } = payload
      const resp = await apiSpec
        .paperwork(bidNumber, siteId)
        .equipment()
        .add(payload)
      const response = resp.data.data
      commit('addEquipment', response.equipment ? response.equipment : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async removeEquipment({ commit }, payload) {
    try {
      const { bidNumber, siteId, id } = payload
      const resp = await apiSpec
        .paperwork(bidNumber, siteId)
        .equipment()
        .remove(id)
      const response = resp.data.data
      commit('removeEquipment', response.equipment ? response.equipment : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async removeChannel({ commit }, payload) {
    try {
      const { bidNumber, siteId, id, equipment } = payload
      const resp = await apiSpec
        .paperwork(bidNumber, siteId)
        .channel()
        .delete(id)
      const response = resp.data.data
      commit('removeChannel', response.channel ? { id: response?.channel?.id, equipment } : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async saveItem({ commit }, payload) {
    try {
      const { bidNumber, siteId } = payload
      console.log('saveItem payload', payload)
      const resp = await apiSpec.paperwork(bidNumber, siteId).saveItem(payload)
      const response = resp.data.data
      commit('setItem', response.paperwork ? response.paperwork : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async saveDetails({ commit }, payload) {
    try {
      const { bidNumber, siteId } = payload
      const resp = await apiSpec.paperwork(bidNumber, siteId).saveDetails(payload)
      const response = resp.data.data
      commit('setDetails', response.paperwork ? response.paperwork : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
